import React from "react";
import { Flex, Text, NumberInput } from "@mantine/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const OdometerForm = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Text fw={600} c="white" mb="sm" align="center">
        {t("mixer:vehicle:odometer_input_label")}
      </Text>
      <Flex justify="center">
        <StyledNumberInput>
          <NumberInput
            size="lg"
            placeholder="----"
            min={0}
            value={value}
            isAllowed={(e) => {
              return e.value.length <= 6;
            }}
            onValueChange={(e) => {
              onChange(e.value);
            }}
            thousandSeparator=","
            hideControls
            allowDecimal={false}
            allowLeadingZeros={false}
            w={200}
            pattern="[0-9]*"
            inputMode="numeric"
          />
        </StyledNumberInput>
        {/* <PinInput
          length={6}
          placeholder="-"
          label="Odometer"
          inputMode="numeric"
          autoFocus
          size="sm"
          value={value}
          onChange={(e) => onChange(e)}
        /> */}
      </Flex>
    </div>
  );
};

export default OdometerForm;

const StyledNumberInput = styled.div`
  input {
    text-align: center;
    background: linear-gradient(
      180deg,
      #a8e6cf 0%,
      #dcedc1 45%,
      #e8f3d6 50%,
      #dcedc1 55%,
      #a8e6cf 100%
    );
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    font-family: "DS-Digital", monospace;
    font-weight: 900;
    border: none;
    color: #2d5a27;
    font-size: 2.5em;
  }

  input::placeholder {
    color: rgba(45, 90, 39, 0.5);
    font-size: 0.65em !important;
  }
`;
